import { useEffect } from 'react'
import { ConfigProvider, theme } from 'antd'
import ruRU from 'antd/locale/ru_RU'
import { useThemeStore } from '@/store/theme'

const TEAL_TOKENS = {
  colorPrimary: '#13c2c2',
  colorLink: '#13c2c2',
  colorLinkHover: '#36cfc9',
  borderRadius: 6,
}

interface ThemeProviderProps {
  children: React.ReactNode
}

export function ThemeProvider({ children }: ThemeProviderProps) {
  const resolved = useThemeStore((s) => s.resolved)
  const syncSystem = useThemeStore((s) => s.syncSystem)

  useEffect(() => {
    const mql = window.matchMedia('(prefers-color-scheme: dark)')
    const handler = (e: MediaQueryListEvent) => syncSystem(e.matches)
    mql.addEventListener('change', handler)
    return () => mql.removeEventListener('change', handler)
  }, [syncSystem])

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', resolved)
  }, [resolved])

  const isDark = resolved === 'dark'

  return (
    <ConfigProvider
      locale={ruRU}
      theme={{
        algorithm: isDark ? theme.darkAlgorithm : theme.defaultAlgorithm,
        token: TEAL_TOKENS,
        components: {
          Layout: {
            headerBg: isDark ? '#141414' : '#ffffff',
            siderBg: isDark ? '#141414' : '#ffffff',
            bodyBg: isDark ? '#000000' : '#f0f2f5',
          },
        },
      }}
    >
      {children}
    </ConfigProvider>
  )
}
